export const checkThumbnail = `<svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M5.99938 14.1129L1.85938 9.97293L3.74604 8.08626L5.99938 10.3463L12.586 3.75293L14.4727 5.6396L5.99938 14.1129Z" fill="black"/>
</svg>`;
